import RotatedArrow from "Components/rotatedArrow";
import classNames from "classnames";
import { Popover } from "devextreme-react/popover";
import React, { useMemo } from "react";
import { v4 as uuid } from "uuid";
const position = {
    my: "right",
    at: "left",
    offset: "6 4"
};
const wrapperAttr = {
    class: "popover-as-dropdown"
};
export default function MenuItem(props) {
    const { id: propsId, className, text, href, target, subMenuItems, onClick, content, ...other } = props;
    const id = useMemo(() => propsId || `menuItem_${uuid()}`, [propsId]);
    const hasSubMenu = subMenuItems && subMenuItems.length > 0;
    return (React.createElement("li", { ...other, className: classNames(className, "position-relative"), id: id, role: "none", onClick: evt => {
            !href && evt.preventDefault();
            content && evt.stopPropagation();
            onClick && onClick(evt);
        } }, content !== null && content !== void 0 ? content : React.createElement(href ? "a" : "div", {
        href,
        tabIndex: -1,
        title: text || "",
        target,
        className: "dropdown-menu-item no-text-decoration"
    }, React.createElement("span", { className: "flex-space-between" },
        React.createElement("span", { className: "text" }, text),
        hasSubMenu && (React.createElement("span", { className: "submenu-triangle" },
            React.createElement(RotatedArrow, { className: "text-light-on-surface-variant" }))))),
        hasSubMenu && (React.createElement(Popover, { wrapperAttr: wrapperAttr, target: `#${id}`, container: `#${id}`, position: position, showEvent: "dxhoverstart", hideEvent: "dxhoverend" },
            React.createElement("div", { role: "none", className: "popover-content h-auto-min p-0", onClick: evt => {
                    evt && evt.stopPropagation();
                } },
                React.createElement("ul", { className: "dropdown-menu" }, props.subMenuItems))))));
}
